<template lang="pug">
v-card(color='amber' light)
  v-icon.winner-card-icon(size='50') fas fa-award
  v-card-text
    .subheading.name {{ data.name }}
    v-divider.my-1
    div #[v-icon(small) school] {{ data.school }}
    div(v-if='!hideDetail') #[v-icon(small) email] {{ data.email }}
    div(v-if='!hideDetail') #[v-icon(small) phone] {{ data.phone }}
</template>

<script>
export default {
  name: 'LotteryWinnerCard',
  props: {
    data: {
      default: {},
    },
    hideDetail: {
      default: false,
    },
  },
}
</script>

<style scoped lang="sass">
$d: 1rem

.winner-card-icon
  position: absolute
  bottom: $d
  right: $d
  opacity: .3

.name
  // font-weight: bold
</style>
